import axios from '../Api/api';

export default async function login(params) {
  const request = {
    username: params.username,
    password: params.password,
  }

  await axios.post("account/crm/authenticate/login", request)
    .then((res) => {
      if (res.status === 200) {
        localStorage.setItem('authToken', res.data.data.id_token);
      }
      return res.status
    })
    .catch((res) => {
      throw new Error(res.response.data.message);
    })
}